import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {ToastService} from "../../../services/Toast.service";
import {Session} from "../../../services/Session";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";

declare const _: any;

@Component({
  selector: 'app-tax-strategy-resources',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqFroalaViewComponent],
  templateUrl: './tax-strategy-resources.component.html',
  styleUrl: './tax-strategy-resources.component.scss'
})
export class TaxStrategyResourcesComponent implements OnInit, OnDestroy {
  @Input() taxStrategy: any;
  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  images = [];
  resourceFiles = [];
  currentSelectedImage: any;
  showPreview = false;

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.formatStrategyResourceFiles();
  }

  formatStrategyResourceFiles() {
    _.each(this.taxStrategy.resources.files, (file) => {
      const splitArray = file.name.split('.');
      if (this.isImage(splitArray[splitArray.length - 1])) {
        file.fileType = 'image';
        this.images.push(file);
      } else if (splitArray[splitArray.length - 1] === 'pdf' || splitArray[splitArray.length - 1] === 'PDF') {
        file.fileType = 'pdf';
        this.resourceFiles.push(file);
      } else if (this.isExcel(splitArray[splitArray.length - 1])) {
        file.fileType = 'excel';
        this.resourceFiles.push(file);
      }else {
        file.fileType = '';
        this.resourceFiles.push(file);
      }
    });

    if (this.images.length > 0) {
      this.currentSelectedImage = this.images[0];
      this.showPreview = true;
    }
  }

  isExcel(extension){
    const types = ['xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xlt', 'xltm', 'xltm', 'xltm'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  isImage(extension){
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    if (imageTypes.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  showImagePreview(file) {
    this.currentSelectedImage = file;
    this.showPreview = true;
  }

  downloadVideo(video) {
    window.open(video.link);
  }

}
